export const articles = [
  {
    slug: "2025-chunji-chuanda-qushi",
    title: "2025春季穿搭趋势：轻盈层次感的华丽演绎",
    excerpt: "当春风吹拂，厚重衣物逐渐退场。今年春季，轻盈的层次感穿搭成为主流——从薄纱叠穿到风衣的随性披搭，每一层都在诉说属于你的风格故事。",
    content: `<p>春天的脚步悄然而至，是时候告别厚重的冬装，迎接轻盈与飘逸。2025年春季穿搭趋势，以"轻盈层次感"为核心关键词，强调在保暖与时尚之间找到完美平衡。</p>
<h2>趋势一：薄纱与丝绸的梦幻叠穿</h2>
<p>本季最令人惊艳的趋势莫过于薄纱与丝绸面料的叠穿。选择一件质感轻盈的薄纱罩衫，内搭丝绸吊带裙，既能展现若隐若现的性感，又不失优雅气质。颜色上，鹅黄、香槟粉、薄荷绿是本季的明星色彩，温柔又充满春天气息。</p>
<p>搭配建议：下身可选择高腰阔腿裤，打造"上轻下重"的视觉效果。鞋履方面，尖头小猫跟或方头乐福鞋都是不错的选择。</p>
<h2>趋势二：风衣的随性演绎</h2>
<p>经典风衣在本季被赋予了全新的穿着方式——不再规整地扣好每一粒纽扣，而是随意地披在肩上，或者只在腰间系一条细腰带，营造出不经意的时髦感。</p>
<p>内搭可以选择简约的针织衫与直筒牛仔裤，或者一条印花连衣裙，让风衣成为整体造型的画龙点睛之笔。</p>
<h2>趋势三：配饰的华丽点缀</h2>
<p>春季配饰以"精致而不张扬"为主调。珍珠元素的回归是今年最大亮点——无论是珍珠耳环、项链还是发夹，都能瞬间提升整体造型的精致度。此外，丝巾作为头饰或包饰的搭配方式也值得尝试。</p>
<h2>色彩搭配法则</h2>
<p>2025春季流行色以温暖的中性色为主，搭配少量亮色点缀。奶茶色、燕麦色、奶油白构成基础色盘，再以珊瑚橙或薰衣草紫作为提亮色，打造温柔而有层次感的视觉效果。</p>`,
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20layered%20spring%20outfit%20with%20sheer%20fabric%20and%20trench%20coat%20walking%20in%20blooming%20garden%2C%20soft%20morning%20light%2C%20pastel%20color%20palette%2C%20magazine%20editorial%20photography%2C%20dreamy%20romantic%20aesthetic&width=1200&height=800&seq=article-2025-spring&orientation=landscape",
    category: "chuanda-gonglue",
    date: "2025-03-15",
    author: "林婉清",
    readingTime: 8,
    tags: ["春季穿搭", "层次感", "风衣搭配", "流行趋势"],
    featured: true,
    popular: true,
  },
  {
    slug: "wanli-jiuhui-zhuangrong-jiaocheng",
    title: "华丽晚宴妆容教程：十分钟打造高级感",
    excerpt: "参加晚宴或正式场合，精致的妆容是必不可少的。这篇教程将手把手教你如何在十分钟内完成一个高级感十足的晚宴妆容，让你自信闪耀全场。",
    content: `<p>一场完美的晚宴，不仅需要得体的礼服，更需要与之匹配的精致妆容。今天我们就来分享一套十分钟高级感晚宴妆容的完整教程，即使是化妆新手也能轻松掌握。</p>
<h2>第一步：底妆打造——丝绒哑光肌</h2>
<p>晚宴灯光下，底妆的质感至关重要。选择一款具有柔焦效果的粉底液，用湿润的美妆蛋轻轻拍开，打造自然无瑕的丝绒哑光肌。重点遮瑕部位：眼下三角区、鼻翼两侧和嘴角。最后用透明散粉定妆，确保妆容持久不脱。</p>
<h2>第二步：眼妆——深邃迷人的烟熏渐变</h2>
<p>晚宴妆容的灵魂在于眼妆。选择大地色与金棕色系的眼影，从睫毛根部向上晕染，打造自然的渐变效果。眼尾处可适当加深，拉长眼型。用细闪亮片眼影点缀眼皮中央和卧蚕位置，让眼神在灯光下更加迷人。</p>
<p>眼线选择深棕色或黑色，沿着睫毛根部画一条流畅的细眼线，眼尾微微上扬。贴上自然款假睫毛，刷上浓密型睫毛膏。</p>
<h2>第三步：修容与腮红——立体轮廓</h2>
<p>在灯光下，面部轮廓容易显得扁平。用修容粉轻扫颧骨下方、下颌线和鼻梁两侧，再用高光提亮鼻梁、眉骨和颧骨高点。腮红选择玫瑰色系，从苹果肌向太阳穴方向斜扫，增加立体感。</p>
<h2>第四步：唇妆——气场红唇的完美画法</h2>
<p>先用唇线笔勾勒出清晰的唇形，再选择一支正红色或酒红色的哑光唇膏，从唇中央向外晕染。在唇峰处点上少许高光，让双唇更加饱满立体。</p>`,
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20applying%20luxurious%20evening%20makeup%20with%20golden%20eyeshadow%20and%20red%20lipstick%2C%20vanity%20mirror%20with%20warm%20lighting%2C%20sophisticated%20beauty%20editorial%2C%20soft%20glam%20aesthetic%2C%20cream%20and%20rose%20gold%20tone&width=1200&height=800&seq=article-makeup&orientation=landscape",
    category: "zhuangrong-jiaocheng",
    date: "2025-03-10",
    author: "苏雨桐",
    readingTime: 6,
    tags: ["晚宴妆容", "化妆教程", "红唇", "高级感"],
    featured: true,
    popular: true,
  },
  {
    slug: "gaoji-gan-peishi-dapei-faze",
    title: "高级感配饰搭配法则：少即是多的华丽哲学",
    excerpt: "配饰是造型的灵魂。掌握“少即是多”的搭配哲学，用最精简的配饰打造最高级的华丽感。从耳环到包包，每一件单品的选择都至关重要。",
    content: `<p>在时尚圈有一句名言："配饰决定品味。"一件恰到好处的配饰，能让最基础的白T恤牛仔裤也变得高级感十足。今天我们就来深入探讨高级感配饰的搭配法则。</p>
<h2>法则一：遵循"三点原则"</h2>
<p>所谓"三点原则"，即全身同时佩戴的显眼配饰不超过三件。例如：耳环+项链+手镯，或者耳环+腰带+包包。超过三个视觉焦点，造型容易显得杂乱无章，失去高级感。</p>
<h2>法则二：金属色的统一</h2>
<p>全身的金属配饰应保持色调统一——金色搭配金色，银色搭配银色。混搭不同金属色虽然是一种潮流，但对于追求高级感的造型来说，统一的金属色调更显精致考究。</p>
<h2>法则三：珍珠——永恒的高级感符号</h2>
<p>无论是经典的单排珍珠项链，还是现代感十足的不规则珍珠耳环，珍珠元素总能瞬间提升造型的华丽指数。推荐选择光泽柔和、形状略有差异的巴洛克珍珠，既有珍珠的优雅，又不失个性。</p>
<h2>法则四：包包的选择与搭配</h2>
<p>包包不仅是实用单品，更是造型的重要组成。日常通勤推荐结构感强的托特包或手提包；约会场合可选择精致的小方包或链条包；晚宴则适合小巧的手拿包。颜色上，黑色、米色、酒红色是最百搭的选择。</p>
<h2>法则五：丝巾的百变魔力</h2>
<p>一条质感上乘的真丝丝巾，可以系在颈间、手腕、包包上，甚至作为发带使用。今年流行的系法是将小方巾对折成三角形，松松地系在颈侧，散发不经意间的法式优雅。</p>`,
    image: "https://readdy.ai/api/search-image?query=Luxurious%20accessories%20display%20with%20gold%20jewelry%20pearl%20necklace%20silk%20scarf%20and%20designer%20handbag%20on%20cream%20marble%20surface%2C%20soft%20natural%20lighting%2C%20elegant%20minimal%20composition%2C%20editorial%20product%20photography&width=1200&height=800&seq=article-accessories&orientation=landscape",
    category: "peishi-dapei",
    date: "2025-03-08",
    author: "林婉清",
    readingTime: 7,
    tags: ["配饰搭配", "珍珠", "丝巾", "包包推荐"],
    featured: true,
    popular: false,
  },
  {
    slug: "yuehui-chuanda-zhinan",
    title: "约会穿搭终极指南：让他一眼难忘的华丽造型",
    excerpt: "第一次约会穿什么？纪念日怎么打扮？不同阶段的约会，需要不同的穿搭策略。这份指南帮你轻松应对每一个浪漫时刻，让他为你的品味倾心。",
    content: `<p>约会是展现个人魅力的重要时刻，一套得体又迷人的穿搭，能让你在约会中自信加倍。今天我们就根据不同约会场景，为你量身打造最合适的华丽造型方案。</p>
<h2>场景一：初次约会——温柔而不失个性</h2>
<p>第一次见面，建议选择温柔而有女人味的造型。一条中长款的碎花连衣裙是不错的选择，搭配一件短款针织开衫，既保暖又优雅。颜色以柔和的粉色、米色或淡蓝色为主，给人温柔亲切的第一印象。</p>
<p>鞋履建议：选择一双舒适的中跟尖头鞋（3-5cm），既能拉长腿部线条，又不会因为太高而走路不适。</p>
<h2>场景二：烛光晚餐——华丽性感</h2>
<p>烛光晚餐是展现女性魅力的绝佳场合。推荐选择一条修身的小黑裙或丝绒连衣裙，搭配精致的金属项链和耳环。妆容可以适当加重，特别是眼妆和唇妆，在烛光下会更显迷人性感。</p>
<p>鞋履建议：细跟高跟鞋是烛光晚餐的标配，建议选择8cm左右的跟高，颜色以黑色或金属色为佳。</p>
<h2>场景三：户外约会——休闲中的精致</h2>
<p>公园野餐、艺术展览或咖啡约会，需要在休闲与精致之间找到平衡。一件质感好的羊绒毛衣搭配高腰直筒牛仔裤，外披一件廓形风衣，简约又不失格调。</p>
<p>鞋履建议：方头乐福鞋或复古运动鞋，舒适又不失时尚感。</p>
<h2>场景四：纪念日——全副武装的华丽</h2>
<p>纪念日需要精心打扮。一条设计感强的礼服裙，搭配全套精致首饰，从头到脚散发华丽光芒。发型建议做一个优雅的低发髻或波浪卷发，整体造型感更强。</p>`,
    image: "https://readdy.ai/api/search-image?query=Romantic%20couple%20dinner%20scene%20with%20elegant%20woman%20in%20little%20black%20dress%2C%20candlelight%20ambiance%2C%20luxurious%20restaurant%20interior%2C%20warm%20intimate%20lighting%2C%20editorial%20fashion%20photography&width=1200&height=800&seq=article-date&orientation=landscape",
    category: "changhe-chuanda",
    date: "2025-02-28",
    author: "陈若曦",
    readingTime: 8,
    tags: ["约会穿搭", "连衣裙", "高跟鞋", "浪漫造型"],
    featured: true,
    popular: true,
  },
  {
    slug: "youya-yitai-xiulian-zhinan",
    title: "优雅仪态修炼指南：从站姿到行走的华丽蜕变",
    excerpt: "真正的华丽不止于衣装，更在于举手投足间的优雅气质。掌握正确的站姿、坐姿和行走方式，让你的每一次外出都散发从容与高贵。",
    content: `<p>华丽的穿搭需要优雅的仪态来承载。一个挺拔的身姿、从容的步伐，能让最普通的衣服也穿出高级感。今天我们就来系统地学习优雅仪态的修炼方法。</p>
<h2>站姿：挺拔如松的秘诀</h2>
<p>优雅站姿的核心要点：双脚并拢或微微分开与肩同宽，重心均匀分布在双脚。挺胸收腹，双肩自然下沉并微微后展。下巴微收，头顶向上延伸，想象有一根线从头顶向上牵引。</p>
<p>日常练习：每天靠墙站立10分钟，确保后脑勺、肩胛骨、臀部和脚后跟四点贴墙。坚持一个月，站姿会有显著改善。</p>
<h2>坐姿：端庄优雅的保持</h2>
<p>入座时，先走到椅子前方再转身坐下，不要拖拽椅子发出声响。坐下后只坐椅面的三分之二，背部保持挺直不靠椅背。双腿并拢，微微向一侧倾斜——这就是经典的"公爵夫人斜腿"坐姿。</p>
<p>注意避免：跷二郎腿、双腿大张或不停抖动，这些都会大大减损优雅气质。</p>
<h2>行走：风姿绰约的步伐</h2>
<p>优雅行走的要领：步伐间距保持在一脚长度以内，先脚跟后脚掌落地。双臂自然摆动，幅度不宜过大。目光平视前方，不要低头看手机或地面。</p>
<p>穿高跟鞋行走时，需要特别注意重心控制。将重心放在前脚掌，步伐放小放慢，让每一步都从容不迫。</p>
<h2>手势与表情管理</h2>
<p>说话时手势自然放在腰部以上，动作不宜过大过多。微笑是最好的配饰——保持嘴角微微上扬的浅笑，既不夸张也不冷漠。与人交谈时保持目光接触，展现真诚与自信。</p>`,
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20with%20perfect%20posture%20walking%20gracefully%20in%20luxurious%20hallway%2C%20classic%20architecture%20background%2C%20soft%20natural%20lighting%2C%20sophisticated%20editorial%20portrait%20photography%2C%20warm%20cream%20tone&width=1200&height=800&seq=article-posture&orientation=landscape",
    category: "yitai-xiuyang",
    date: "2025-02-20",
    author: "苏雨桐",
    readingTime: 7,
    tags: ["仪态修炼", "优雅站姿", "行走技巧", "气质提升"],
    featured: false,
    popular: true,
  },
  {
    slug: "dongji-dieceng-chuanda",
    title: "冬季叠穿法则：保暖与时尚兼得的华丽秘籍",
    excerpt: "寒冷的冬天也可以穿得既保暖又时髦。掌握叠穿的核心技巧，用层次感打造丰富的视觉效果，让你在冬日街头依然光彩照人。",
    content: `<p>冬天的穿搭常常面临两难选择——穿得暖就显臃肿，穿得薄又受冻。其实，只要掌握正确的叠穿技巧，保暖与时尚完全可以兼得。</p>
<h2>叠穿基础：三层法则</h2>
<p>专业造型师推荐的冬季叠穿分为三层：内层（贴身保暖层）选择发热内衣或薄款羊绒衫；中层（过渡保温层）选择高领毛衣或针织开衫；外层（防风装饰层）选择大衣、羽绒服或皮草外套。</p>
<h2>面料搭配的艺术</h2>
<p>叠穿的精髓在于不同面料的混搭。丝绒与针织、皮革与羊绒、粗花呢与丝绸——不同质感的碰撞能创造出丰富的视觉层次。建议相邻两层面料选择不同质感，避免同为光滑或同为毛绒的面料相邻。</p>
<h2>色彩搭配建议</h2>
<p>冬季叠穿的配色建议从内向外由浅入深。内层选择米色、浅灰等浅色，中层为中灰色调，外层为深色系如炭灰、藏蓝或黑色。这样的色彩渐变能让身形看起来更加修长。</p>
<h2>配饰的锦上添花</h2>
<p>冬季配饰是造型的点睛之笔。一条羊绒围巾不仅是保暖利器，更能丰富颈部的层次感。皮手套、贝雷帽和长靴的搭配，让冬季造型更加完整和精致。</p>`,
    image: "https://readdy.ai/api/search-image?query=Stylish%20woman%20in%20elegant%20layered%20winter%20outfit%20with%20wool%20coat%20and%20cashmere%20scarf%20walking%20on%20snowy%20city%20street%2C%20soft%20winter%20sunlight%2C%20luxurious%20texture%2C%20editorial%20fashion%20photography&width=1200&height=800&seq=article-winter&orientation=landscape",
    category: "chuanda-gonglue",
    date: "2025-02-15",
    author: "林婉清",
    readingTime: 6,
    tags: ["冬季穿搭", "叠穿技巧", "大衣搭配", "保暖时尚"],
    featured: false,
    popular: true,
  },
  {
    slug: "richang-tongqin-gaoji-gan",
    title: "日常通勤高级感穿搭：上班也要美得毫不费力",
    excerpt: "工作日不等于随便穿。用基础款单品打造高级感通勤造型，让你在每个工作日都自信从容，成为办公室最会穿的人。",
    content: `<p>一周五天的工作日，穿搭既要专业得体，又要展现个人风格。今天我们就来分享如何用最基础的单品，打造高级感十足的通勤造型。</p>
<h2>胶囊衣橱的构建</h2>
<p>通勤穿搭的核心是建立一个高效的胶囊衣橱。建议配置：两条质感好的西裤（黑色+米色）、三件白衬衫（不同领型）、两件羊绒衫（深色+浅色）、一件西装外套、一件风衣。这些基础款可以互相搭配出至少20套不同的造型。</p>
<h2>周一到周五的通勤穿搭方案</h2>
<p><strong>周一：</strong>黑色吸烟西裤+白色真丝衬衫+驼色风衣，干练有气场。搭配黑色尖头高跟鞋和简约托特包。</p>
<p><strong>周二：</strong>米色阔腿西裤+灰色羊绒衫+黑色西装外套，温柔有质感。搭配方头乐福鞋增加舒适感。</p>
<p><strong>周三：</strong>驼色铅笔裙+白色飘带衬衫，优雅知性。搭配珍珠耳环和链条包。</p>
<p><strong>周四：</strong>深蓝直筒西裤+条纹衬衫+针织开衫，轻松有格调。搭配复古小白鞋。</p>
<p><strong>周五：</strong>黑色阔腿裤+红色真丝衬衫，周五可以稍微大胆一点。搭配金属色配饰点亮整体。</p>
<h2>通勤配饰的选择</h2>
<p>通勤配饰以简约精致为主。推荐：一只品质好的手表、一对简约的金属耳环、一条细链条项链。这些配饰低调却显质感，完美呼应职业女性的身份。</p>`,
    image: "https://readdy.ai/api/search-image?query=Professional%20elegant%20woman%20in%20sophisticated%20office%20outfit%20with%20blazer%20and%20wide%20leg%20trousers%2C%20modern%20minimal%20office%20interior%2C%20natural%20daylight%2C%20editorial%20corporate%20fashion%20photography&width=1200&height=800&seq=article-office&orientation=landscape",
    category: "chuanda-gonglue",
    date: "2025-02-10",
    author: "陈若曦",
    readingTime: 7,
    tags: ["通勤穿搭", "职场造型", "胶囊衣橱", "OL时尚"],
    featured: false,
    popular: false,
  },
  {
    slug: "sichou-mi-mi-si-jin-dapei",
    title: "丝绸的秘密：丝巾搭配的无限可能",
    excerpt: "一条丝巾的华丽变身——从经典颈部系法到创意发饰，从包包装饰到腕间风情。解锁丝巾的多种玩法，让你的造型瞬间提升档次。",
    content: `<p>丝巾是配饰世界中最具魔法色彩的单品之一。一条90cm见方的真丝丝巾，可以变幻出数十种不同的搭配方式。今天就让我们来解锁丝巾的无限可能。</p>
<h2>经典颈部系法</h2>
<p><strong>巴黎结：</strong>将丝巾对折成三角形，松松地围在颈部，在侧面打一个随性的小结。这是最法式的系法，优雅不费力。</p>
<p><strong>领巾结：</strong>将丝巾折成细条，像系领带一样绕颈一圈，在前面打一个蝴蝶结。适合搭配衬衫或V领针织衫。</p>
<p><strong>项圈式：</strong>将丝巾折成细条紧贴颈部缠绕，在后方打结。这种系法最适合搭配大领口的衣服，突出颈部线条。</p>
<h2>创意发饰用法</h2>
<p>丝巾作为发饰有多重玩法：可以折叠后作为发箍绑在头顶，也可以编入发辫中增加色彩，还能包裹整个头部打造复古名伶风。今年最流行的是将小方巾对折后系在低马尾上，随性又精致。</p>
<h2>包饰与腕饰</h2>
<p>将丝巾缠绕在包带上，是最简单却效果显著的装饰方法。选择与包包颜色形成对比的丝巾，让包包焕然一新。也可以将丝巾绕在手腕上，替代手镯或手表，打造独特的腕间风情。</p>`,
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20styling%20luxurious%20silk%20scarf%20in%20multiple%20ways%20neck%20hair%20and%20handbag%2C%20soft%20natural%20lighting%2C%20warm%20beige%20background%2C%20editorial%20fashion%20photography%2C%20refined%20feminine%20aesthetic&width=1200&height=800&seq=article-scarf&orientation=landscape",
    category: "peishi-dapei",
    date: "2025-02-05",
    author: "苏雨桐",
    readingTime: 5,
    tags: ["丝巾搭配", "配饰技巧", "法式优雅", "造型灵感"],
    featured: false,
    popular: false,
  },
  {
    slug: "paidui-zhuangban-daren-jingxuan",
    title: "派对装扮达人精选：成为全场焦点的华丽秘籍",
    excerpt: "年末派对季即将到来，你准备好了吗？从公司年会到朋友聚会，从圣诞派对到跨年盛典，不同派对场合的穿搭攻略一次奉上。",
    content: `<p>派对是展现个人风格的绝佳舞台。不同主题、不同场合的派对，需要不同的穿搭策略。这份派对穿搭全攻略，让你在任何派对上都能成为最耀眼的存在。</p>
<h2>公司年会——端庄大气中不失亮点</h2>
<p>公司年会需要兼顾职业形象与节日氛围。推荐选择中长款的礼服裙或丝绒连体裤，颜色以深蓝、酒红、祖母绿为主。设计上可以有适当的露肤（如V领或露背），但不宜过于性感。搭配精致的金属配饰和简约手拿包。</p>
<h2>闺蜜派对——大胆尝试潮流元素</h2>
<p>和闺蜜的聚会可以尽情发挥穿搭创意。亮片裙、羽毛装饰、金属色单品——这些平时不太穿的潮流元素，都可以在闺蜜派对上大胆尝试。不必担心"太过"，尽情享受时尚的乐趣。</p>
<h2>正式晚宴——经典优雅永不过时</h2>
<p>正式晚宴需要遵循传统的着装礼仪。选择一条及地长裙或精致的鸡尾酒裙，面料以丝绸、丝绒或蕾丝为佳。搭配全套高级珠宝和晚宴包，发型建议做精致的盘发。</p>
<h2>户外派对——实用与时尚兼顾</h2>
<p>花园派对或泳池派对等户外场合，穿搭需要兼顾美观与实用。选择轻盈飘逸的面料如雪纺或真丝，搭配平底凉鞋或粗跟鞋，避免细跟陷入草地。一顶宽檐帽既能防晒又能增加造型感。</p>`,
    image: "https://readdy.ai/api/search-image?query=Glamorous%20women%20at%20elegant%20cocktail%20party%20in%20sparkling%20evening%20dresses%2C%20luxurious%20venue%20with%20chandeliers%2C%20warm%20golden%20lighting%2C%20editorial%20party%20photography%2C%20sophisticated%20celebration%20aesthetic&width=1200&height=800&seq=article-party&orientation=landscape",
    category: "changhe-chuanda",
    date: "2025-01-28",
    author: "林婉清",
    readingTime: 7,
    tags: ["派对穿搭", "礼服", "晚宴", "派对造型"],
    featured: false,
    popular: true,
  },
  {
    slug: "chuji-hua-zhuang-xinshou-bibei",
    title: "新手化妆必备清单：从零开始的华丽蜕变",
    excerpt: "刚开始学化妆不知道从何下手？这份新手化妆必备清单，帮你理清哪些产品是真正必需的，哪些可以后面再慢慢添置，少花冤枉钱。",
    content: `<p>化妆新手面对琳琅满目的美妆产品，往往不知从何下手。今天我们就来整理一份实用又精简的新手化妆必备清单，帮你用最少的投入开启华丽妆容之旅。</p>
<h2>底妆篇</h2>
<p><strong>必备：</strong>妆前乳、粉底液（或气垫）、遮瑕膏、散粉。新手建议选择气垫BB霜替代粉底液，更容易上手。颜色选择比肤色亮半个色号，打造自然提亮效果。</p>
<p><strong>进阶：</strong>隔离霜、修容盘、高光粉。这些可以在熟练基础底妆后逐步添加。</p>
<h2>眉妆篇</h2>
<p>眉笔或眉粉是必选项。新手推荐使用自动旋转眉笔，选择比发色浅一号的颜色。眉形按照三点定位法确定眉头、眉峰和眉尾的位置。</p>
<h2>眼妆篇</h2>
<p><strong>必备：</strong>四色眼影盘（建议选择大地色系）、眼线笔、睫毛膏。大地色系最不容易出错，适合日常各种场合。</p>
<p><strong>进阶：</strong>彩色眼影盘、眼线液笔、假睫毛。等熟练掌握基础眼妆后再挑战。</p>
<h2>唇妆与腮红</h2>
<p>一支日常色唇膏（豆沙色或奶茶色）和一支场合色（正红色或梅子色）是基本配置。腮红选择蜜桃色或玫瑰色系，最百搭不挑肤色。</p>
<h2>工具篇</h2>
<p>必备工具：美妆蛋（上底妆）、一套基础化妆刷（散粉刷、眼影刷、腮红刷各一把）。建议投资好质量的化妆刷，使用体验和妆效都会更好。</p>`,
    image: "https://readdy.ai/api/search-image?query=Organized%20makeup%20products%20on%20vanity%20table%20with%20brushes%20foundation%20eyeshadow%20palette%20and%20lipstick%2C%20soft%20warm%20lighting%2C%20clean%20minimal%20composition%2C%20beauty%20editorial%20photography&width=1200&height=800&seq=article-beginner&orientation=landscape",
    category: "zhuangrong-jiaocheng",
    date: "2025-01-20",
    author: "陈若曦",
    readingTime: 6,
    tags: ["新手化妆", "化妆必备", "美妆入门", "化妆品推荐"],
    featured: false,
    popular: false,
  },
  {
    slug: "xiangshui-xuanze-shiyong-zhinan",
    title: "香水选择与使用指南：用气味书写你的华丽名片",
    excerpt: "香水是看不见的华服，是气味的身份印记。学会选择适合自己的香水并正确使用，让每一次经过都留下令人心动的气息。",
    content: `<p>玛丽莲·梦露曾说，她只穿Chanel No.5入睡。香水是女性最隐秘也最具辨识度的"衣物"。选对一款香水，就像找到了一件永远不会过时的经典单品。</p>
<h2>香水的浓度分类</h2>
<p>香水按浓度从高到低分为：香精（Parfum，浓度20-30%，持香6-8小时）、淡香精（EDP，浓度15-20%，持香4-6小时）、淡香水（EDT，浓度5-15%，持香3-4小时）、古龙水（EDC，浓度2-5%，持香1-2小时）。日常推荐选择EDP或EDT，既有足够的持香时间，又不会过于浓烈。</p>
<h2>香调的选择</h2>
<p><strong>花香调：</strong>以玫瑰、茉莉、晚香玉等为主，温柔浪漫，适合约会和日常。</p>
<p><strong>木质调：</strong>以檀木、雪松、广藿香为主，沉稳大气，适合职场和正式场合。</p>
<p><strong>果香调：</strong>以柑橘、桃子、莓果为主，清新活泼，适合春夏和休闲场合。</p>
<p><strong>东方调：</strong>以琥珀、香草、麝香为主，神秘性感，适合晚宴和派对。</p>
<h2>正确的使用方式</h2>
<p>喷香水的最佳位置是脉搏点——手腕内侧、耳后、颈侧、肘窝和膝盖后侧。这些部位体温较高，能帮助香气更好地散发。注意不要揉搓手腕，会破坏香水分子结构，影响香气层次。</p>
<p>一个小技巧：在涂抹身体乳后喷香水，持香时间会更长。也可以将香水喷在发梳上再梳理头发，让发丝也带上淡淡香气。</p>`,
    image: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20on%20luxurious%20vanity%20table%20with%20soft%20warm%20lighting%20and%20fresh%20flowers%2C%20golden%20accents%2C%20sophisticated%20beauty%20editorial%2C%20refined%20feminine%20aesthetic%2C%20cream%20background&width=1200&height=800&seq=article-perfume&orientation=landscape",
    category: "yitai-xiuyang",
    date: "2025-01-15",
    author: "苏雨桐",
    readingTime: 5,
    tags: ["香水", "香调选择", "气质提升", "使用方法"],
    featured: false,
    popular: false,
  },
  {
    slug: "xiari-qingliang-chuanda",
    title: "夏日清凉穿搭：炎炎夏日也要华丽出行",
    excerpt: "高温天气不等于放弃时尚。用轻盈的面料、清爽的色彩和巧妙的搭配，让你的夏日造型既清凉舒适又不失华丽质感。",
    content: `<p>夏日的热浪来袭，如何在高温中保持清凉又不失时尚感？这份夏日穿搭指南帮你轻松应对炎炎夏日，让每一次外出都清爽又华丽。</p>
<h2>面料选择——透气是第一要义</h2>
<p>夏季穿搭的面料选择至关重要。优先选择天然纤维：纯棉、亚麻、真丝和天丝。这些面料透气性好，吸湿排汗，能让皮肤自由呼吸。避免化纤面料，虽然好看但闷热不透气。</p>
<p>特别推荐亚麻混纺面料——相比纯亚麻不易起皱，同时保留了凉爽透气的优点，是夏季通勤的最佳选择。</p>
<h2>色彩搭配——清爽降温的视觉魔法</h2>
<p>浅色系在视觉上有降温效果。白色、米色、浅蓝、薄荷绿是本季首选。如果觉得全浅色太单调，可以用亮色配饰做点缀——一条亮黄色的丝巾或一双红色的凉鞋，就能让整体造型活起来。</p>
<h2>单品推荐</h2>
<p><strong>吊带连衣裙：</strong>夏日最省心又好看的单品。选择真丝或丝棉混纺面料，印花或纯色都好看。白天单穿，晚上加一件薄开衫即可应对温差。</p>
<p><strong>阔腿裤：</strong>比紧身裤凉爽太多，而且走路带风，气场十足。搭配简约吊带或短款T恤都很好看。</p>
<p><strong>防晒罩衫：</strong>选择半透明的雪纺或欧根纱材质，既能防晒，又不会遮挡内搭的美感，还能增加层次感。</p>`,
    image: "https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20flowy%20summer%20dress%20walking%20on%20sunny%20beachside%20promenade%2C%20light%20airy%20fabric%2C%20fresh%20pastel%20colors%2C%20soft%20golden%20sunlight%2C%20editorial%20summer%20fashion%20photography&width=1200&height=800&seq=article-summer&orientation=landscape",
    category: "chuanda-gonglue",
    date: "2025-01-10",
    author: "林婉清",
    readingTime: 6,
    tags: ["夏季穿搭", "清凉造型", "面料选择", "夏日时尚"],
    featured: false,
    popular: false,
  },
];

export const articleMap: Record<string, typeof articles[0]> = {};
articles.forEach((article) => {
  articleMap[article.slug] = article;
});

export function getArticlesByCategory(categorySlug: string) {
  return articles.filter((a) => a.category === categorySlug);
}

export function getFeaturedArticles() {
  return articles.filter((a) => a.featured);
}

export function getPopularArticles() {
  return articles.filter((a) => a.popular);
}